module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "load-view"
  }, [((_vm.state == 'ready') || (_vm.state == 'working')) ? _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand",
    class: {
      blurred: _vm.state == 'working'
    }
  }, [_c('div', {
    staticClass: "file-list-holder"
  }, [_c('FileList', {
    attrs: {
      "contentType": _vm.contentType
    },
    on: {
      "selected": _vm.selected
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.state == 'ready' || _vm.state == 'working') ? _c('div', {
    staticClass: "mdl-card__actions mdl-card--border",
    class: {
      blurred: _vm.state == 'working'
    }
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    attrs: {
      "disabled": !_vm.selectedFile
    },
    on: {
      "click": _vm.load
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("cloud_download")]), _vm._v(" " + _vm._s(_vm.i18n().loadFromCloud) + "\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "upload"
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("file_upload")]), _vm._v(" " + _vm._s(_vm.i18n().upload) + "\n      ")]), _vm._v(" "), _c('input', {
    staticClass: "hidden-file",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.handleInputChange
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.state == 'working') ? _c('div', {
    staticClass: "working"
  }, [_c('div', {
    staticClass: "mdl-spinner mdl-js-spinner is-active"
  })]) : _vm._e(), _vm._v(" "), (_vm.state == 'done') ? _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand done"
  }, [_c('p', [_vm._v(_vm._s(_vm.i18n().loaded(_vm.fileName)))])]) : _vm._e(), _vm._v(" "), (_vm.state == 'error') ? _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand error"
  }, [_c('p', [_vm._v(_vm._s(_vm.i18n().loadError(_vm.error)))])]) : _vm._e(), _vm._v(" "), (_vm.state == 'error' || _vm.state == 'done') ? _c('div', {
    staticClass: "mdl-card__actions mdl-card--border"
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("done")]), _vm._v(_vm._s(_vm.i18n().ok) + "\n    ")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68a5abd5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/save/LoadView.vue
// module id = 455
// module chunks = 0